import { useRef } from 'react';
const useRallyFormRefs = () => {
    const orderedRefs = [
        ['firstName', useRef(null)],
        ['lastName', useRef(null)],
        ['email', useRef(null)],
        ['password', useRef(null)],
        ['confirmPassword', useRef(null)],
    ];
    return { refs: Object.fromEntries(orderedRefs), orderedRefs };
};
export default useRallyFormRefs;
